/** Plain share row for blog articles (no rewards mechanics). */
import { Copy, Linkedin, Share2, Twitter } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

export function ArticleShareButtons({ title, url: givenUrl, variant = "inline" }: { title: string; url?: string; variant?: "inline" | "sidebar" }) {
  const { language } = useLanguage();
  const isEl = language === "el";
  // The canonical URL when the page gives one: the same in the prerendered
  // HTML and in the browser, and free of tracking parameters.
  const url = givenUrl ?? (typeof window !== "undefined" ? window.location.href.split("#")[0] : "");
  const enc = encodeURIComponent;

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success(isEl ? "Το link αντιγράφηκε" : "Link copied"); }
    catch { toast.error(isEl ? "Δεν έγινε αντιγραφή" : "Could not copy"); }
  };

  return (
    <div className={variant === "sidebar" ? "p-5 rounded-2xl border border-border/40 bg-card/30" : "mt-10 flex flex-wrap items-center gap-2"}>
      <div className={variant === "sidebar" ? "flex items-center gap-2 mb-3" : "flex items-center gap-2 mr-2"}>
        <Share2 className="h-4 w-4 text-primary" />
        <span className="text-sm font-medium">{isEl ? "Μοιράσου το άρθρο" : "Share this article"}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button asChild variant="outline" size="sm" className="gap-1.5">
          <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`} target="_blank" rel="noopener noreferrer"><Linkedin className="h-3.5 w-3.5" /> LinkedIn</a>
        </Button>
        <Button asChild variant="outline" size="sm" className="gap-1.5">
          <a href={`https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`} target="_blank" rel="noopener noreferrer"><Twitter className="h-3.5 w-3.5" /> X</a>
        </Button>
        <Button variant="outline" size="sm" className="gap-1.5" onClick={copy}><Copy className="h-3.5 w-3.5" /> {isEl ? "Αντιγραφή" : "Copy link"}</Button>
      </div>
    </div>
  );
}
